export { default } from './ProductDestock';
